// import { offersApi } from '@/api';
import { ANALYSES_COMMODITY_CATEGORIES } from '@/config/constants';

const sampleAnalyses = [
  {
    name: 'docNumber',
    label: 'offerNumber',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'commodityCategory',
    label: 'testType',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'enums.commodityCategory.chemical', value: ANALYSES_COMMODITY_CATEGORIES.CHEMICAL },
      { label: 'enums.commodityCategory.microbiological', value: ANALYSES_COMMODITY_CATEGORIES.MICROBIOLOGICAL },
    ],
  },
  {
    name: 'familyCode',
    label: 'familyCode',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'enums.familyCode.CBC', value: 'CBC' },
      { label: 'enums.familyCode.CCL', value: 'CCL' },
      { label: 'enums.familyCode.CCO', value: 'CCO' },
      { label: 'enums.familyCode.CCV', value: 'CCV' },
      { label: 'enums.familyCode.CCVR', value: 'CCVR' },
      { label: 'enums.familyCode.CDI', value: 'CDI' },
      { label: 'enums.familyCode.CEL', value: 'CEL' },
      { label: 'enums.familyCode.CID', value: 'CID' },
      { label: 'enums.familyCode.CIDR', value: 'CIDR' },
      { label: 'enums.familyCode.CPR', value: 'CPR' },
      { label: 'enums.familyCode.CPRR', value: 'CPRR' },
      { label: 'enums.familyCode.CPU', value: 'CPU' },
      { label: 'enums.familyCode.CST', value: 'CST' },
      { label: 'enums.familyCode.CSU', value: 'CSU' },
      { label: 'enums.familyCode.CTI', value: 'CTI' },
      { label: 'enums.familyCode.CTIR', value: 'CTIR' },
      { label: 'enums.familyCode.CTL', value: 'CTL' },
      { label: 'enums.familyCode.CTS', value: 'CTS' },
      { label: 'enums.familyCode.MAD', value: 'MAD' },
      { label: 'enums.familyCode.MAM', value: 'MAM' },
      { label: 'enums.familyCode.MAV', value: 'MAV' },
      { label: 'enums.familyCode.MBC', value: 'MBC' },
      { label: 'enums.familyCode.MCH', value: 'MCH' },
      { label: 'enums.familyCode.MCM', value: 'MCM' },
      { label: 'enums.familyCode.MCN', value: 'MCN' },
      { label: 'enums.familyCode.MCO', value: 'MCO' },
      { label: 'enums.familyCode.MCOR', value: 'MCOR' },
      { label: 'enums.familyCode.MCR', value: 'MCR' },
      { label: 'enums.familyCode.MOP', value: 'MOP' },
      { label: 'enums.familyCode.MRI', value: 'MRI' },
      { label: 'enums.familyCode.MST', value: 'MST' },
      { label: 'enums.familyCode.MTU', value: 'MTU' },
    ],
  },
  {
    name: 'code',
    label: 'code',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'description',
    label: 'description',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'status',
    label: 'status',
    type: 'select',
    permissions: ['admin'],
    whereOperator: '=',
    options: [
      { label: 'filters.disabled', value: 0 },
      { label: 'filters.enabled', value: 1 },
    ],
  },
  {
    name: 'hasExpiredOffer',
    label: 'hasExpiredOffer',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'enums.commons.no', value: false },
      { label: 'enums.commons.yes', value: true },
    ],
  },
];

export default sampleAnalyses;
